import React from "react";
import { useState } from "react";

import { Autocomplete, Button, Stack, TextField } from "@mui/material";
import { PopoverContentProps } from "components/AiData/PopoverContent";

export const ClassificationPopoverContent: React.FC<PopoverContentProps> = ({
  openedCell,
  setOpenedCell,
  onChangeSpecificRecommendationValue
}) => {
  const classificationOptions = [
    "Investment",
    "Management Fees",
    "Other Fees",
    "Return of Capital",
    "Dividends",
    "Other distribution"
  ];
  const [classification, setClassification] = useState<string>(openedCell?.data.parameter.classification || "");

  return (
    <>
      <Autocomplete
        disableClearable
        fullWidth
        value={classification}
        options={classificationOptions}
        slotProps={{
          popper: {
            placement: "bottom-start",
            modifiers: [
              {
                name: "preventOverflow",
                enabled: true,
                options: {
                  boundary: "viewport",
                  padding: 8
                }
              },
              {
                name: "flip",
                enabled: true,
                options: {
                  fallbackPlacements: ["top-start", "bottom-end", "top-end"]
                }
              }
            ]
          }
        }}
        renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: string) => (
          <li {...props} key={option}>
            {option}
          </li>
        )}
        renderInput={(params) => <TextField {...params} label="Classification" />}
        getOptionLabel={(option) => option}
        onChange={(_, option) => setClassification(option)}
      />

      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "10px" }}>
        <Button
          variant="outlined"
          onClick={() => {
            setOpenedCell(null);
            setClassification("");
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={async () => {
            if (openedCell?.data && classification) {
              openedCell.data.parameter.id &&
                (await onChangeSpecificRecommendationValue({
                  id: openedCell.data.parameter.id,
                  field: "classification",
                  value: classification
                }));
            }
            setOpenedCell(null);
          }}
          variant="contained"
        >
          Apply
        </Button>
      </Stack>
    </>
  );
};
